// src/components/Shared/RecipeCards/RecipeCardCompact.tsx
// @ts-nocheck
import React from 'react';
import { Link } from 'react-router-dom';
import { getAvatarURL } from '../../../utils/avatar';
import SplitActionButton from '../../ui/atoms/Button/SplitActionButton';
import RecipeTagList from '../../ui/molecules/RecipeTagList';

interface RecipeCardCompactProps {
  recipe: any;
  /** whether this recipe is already bookmarked */
  isBookmarked: boolean;
  /** callback to toggle the bookmark */
  onToggleBookmark: () => void;
  /** called when user clicks “Add to Meal Plan” */
  onAddToPlan: () => void;
}

const RecipeCardCompact: React.FC<RecipeCardCompactProps> = ({
  recipe,
  isBookmarked,
  onToggleBookmark,
  onAddToPlan,
}) => {
  const creator = recipe.user;
  const fallbackRecipeImage = '/no-image.png';

  return (
    <div className="flex-shrink-0 w-[230px]">
      {/* Entire card is clickable except the split button */}
      <Link
       to={`/app/recipe/${recipe.id}`}
       className="
         block
         relative
         w-full
         h-[250px]            /* ← fix the total height to whatever you need */
         bg-white
         rounded-lg
         shadow-sm
         border
         overflow-hidden      /* hide anything that spills out */
         hover:shadow-md
         transition
         flex
         flex-col
       "
     >
        {/* IMAGE + overlaid split-action button */}
        <div className="relative w-full h-[140px]">
          <img
            src={recipe.imageUrl || fallbackRecipeImage}
            alt={recipe.title}
            className="w-full h-full object-cover"
            onError={(e) => {
              const t = e.currentTarget;
              t.onerror = null;
              t.src = fallbackRecipeImage;
            }}
          />
          <div className="absolute bottom-0 right-0">
            <SplitActionButton
              variant="search"
              isBookmarked={isBookmarked}
              onToggleBookmark={(e: React.MouseEvent) => {
                e.preventDefault();
                e.stopPropagation();
                onToggleBookmark();
              }}
              onAddToMealPlan={(e: React.MouseEvent) => {
                e.preventDefault();
                e.stopPropagation();
                onAddToPlan();
              }}
            />
          </div>
        </div>

        {/* CONTENT */}
        <div className="px-3 pt-3 flex flex-col flex-1">
          <h3 className="font-heading text-dark text-m font-semibold truncate mb-2">
            {recipe.title}
          </h3>

          <div className="flex items-center space-x-1 text-xs text-gray-500 mb-2 h-5">
            {creator ? (
              <>
                <img
                  src={getAvatarURL(creator)}
                  alt="avatar"
                  className="w-5 h-5 rounded-full"
                />
                <span className="truncate">
                  {creator.name || creator.username}
                </span>
              </>
            ) : (
              <div className="w-full h-5" />
            )}
          </div>
        </div>

        {/* TAGS */}
        <div
         className="
           px-3
           pb-3
           h-[1.75rem]       /* about one tag-line high; tweak to match your Tag pill height */
           overflow-hidden   /* hide any wrapped tags */
           relative
         "
       >
          <RecipeTagList
            recipeTags={recipe.recipeTags}
            context="home"
          />
        </div>
      </Link>
    </div>
  );
};

export default RecipeCardCompact;
